import useUXStore from "../../api/ux/store"
import ButtonControl from "../../components/ButtonControl"
import CAccordion from "../../components/CAccordion"
import CStack from "../../components/CStack"
import EditorControl from "../../components/EditorControl"
import InputItem from "../../components/InputItem"
import ClientItem, { AddClientView } from "./ClientItem"
import { useState } from "react"
import { AppData, ClientData } from "../../api/apps/data"
import { useApps } from "../../api/apps/store"
import Label from "../../components/Label"
import RoleItem from "./RoleItem"
import DropdownControl from "../../components/DropdownControl"
import { ReactComponent as AddIcon } from "../../svgs/add_outline.svg"
import { useAuth } from "../../api/auth/store"
import { SUPPORT_ROLE } from "../../constants"

const StatusList = ["Disabled", "Alpha", "Beta", "Released", "Internal"]
const StatusColors = ["red", "gray", "blue", "green", "black"]
const defaultApp: AppData = { id: "testapp", name: "Test App", desc: "Hello" }



const AppItem = ({
    app = defaultApp,
    onDelete = (app: string) => { },
    onUpdate = async (app: AppData) => { },
    onDeleteClient = (client: ClientData) => { },
    onAddedClient = () => { }
}) => {
    const { refreshDialog } = useUXStore(state => state)
    const { uploadIcon } = useApps(state => state)
    const [uploading, setUploading] = useState({ small: false, large: false })
    const onDeleteApp = (appd: AppData) => {
        refreshDialog({
            id: "deleteApp",
            title: "Delete App",
            visible: true,
            content: <div>Are you sure you want to delete app <b>{appd.name}</b>?</div>,
            onConfirm() {
                onDelete(appd.id!)
            },
        }, true)
    }
    const onAddClient = () => {
        refreshDialog({
            id: "addClient",
            visible: true,
            title: "Add Client",
            content: <AddClientView app={app.id} onAdded={onAddedClient} />,
            onConfirm: undefined,
        }, true)
    }
    const onApply = async (newdata: any) => {
        //console.log(newdata)
        onUpdate(newdata)
    }
    const onIconChanged = (file: File, small: boolean) => {
        setUploading({ ...uploading, [small ? "small" : "large"]: true })
        uploadIcon(file, small, app.id!)
            .then(res => {
            })
            .catch(err => {
                console.error(err)
            })
            .finally(() => setUploading({ ...uploading, [small ? "small" : "large"]: false }))
    }
    const { hasRole } = useAuth(state => state)
    const editable = !hasRole(SUPPORT_ROLE)

    return <CAccordion label={app.name} icon={app.icons}>
        <EditorControl editable={editable} defaultData={app} onApply={onApply}>
            {(data, onChanged, edit) => <>
                <InputItem edit={false} text="Id" value={data.id} />
                <InputItem edit={edit} text="Name" id="name" value={data.name} onChanged={onChanged} />
                <InputItem edit={edit} text="Description" id="desc" value={data.desc} onChanged={onChanged} />
                <DropdownControl edit={edit} text="Status" textColor={StatusColors[data.status]} selected={data.status} items={StatusList} onSelected={(val, i) => onChanged("status", i)} />
                <InputItem edit={edit} text="Link" id="link" value={data.link} onChanged={onChanged} />
                <InputItem edit={edit}
                    isImage
                    text="Icon Small"
                    loading={uploading.small}
                    onImageChanged={(file: File) => onIconChanged(file, true)}
                    id="icons"
                    value={data.icons}
                    onChanged={onChanged} />
                <InputItem edit={edit}
                    isImage
                    text="Icon Large"
                    loading={uploading.large}
                    onImageChanged={(file: File) => onIconChanged(file, false)}
                    id="iconl"
                    value={data.iconl}
                    onChanged={onChanged} />
                <RoleItem app={data} editable={editable} />
                <CStack header="Clients" actions={editable ? [{ icon: <AddIcon stroke="rgb(103, 158, 255)" height={25} width={25} />, onClick: onAddClient }] : []}>
                    {
                        app.clients && app.clients.map(client =>
                            <ClientItem client={client} onDelete={onDeleteClient} />
                        )
                    }
                    {!app.clients && <Label fontWeight="400" size="medium">No Client </Label>}
                </CStack>
                {edit && <ButtonControl labelColor="red"
                    text="Delete App"
                    buttonLabel="Delete"
                    variant="outline-danger"
                    onClicked={() => onDeleteApp(data)} />}
            </>}
        </EditorControl>
    </CAccordion>
}

export default AppItem